import { PageStatus } from '../../typings/common';
import { GdShowConditionAutobudgetPriority } from '../../typings/graphql-grid';

export const CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY = 'CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY';
export type CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY = typeof CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY;

export interface ChangeFeedFiltersAutobudgetPriorityAction {
    type: CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY;
    autobudgetPriority: GdShowConditionAutobudgetPriority;
}

export function changeFeedFiltersAutobudgetPriority(
    autobudgetPriority: GdShowConditionAutobudgetPriority
): ChangeFeedFiltersAutobudgetPriorityAction {
    return {
        type: CHANGE_FEED_FILTERS_AUTOBUDGET_PRIORITY,
        autobudgetPriority
    };
}

export const UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY = 'UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY';
export type UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY = typeof UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY;

export interface UpdateFeedFiltersAutobudgetPriorityAction {
    type: UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY;
    filtersIds: Array<string>;
}

export function updateFeedFiltersAutobudgetPriority(
    filtersIds: Array<string>
): UpdateFeedFiltersAutobudgetPriorityAction {
    return {
        type: UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY,
        filtersIds
    };
}

export const UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT = 'UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT';
export type UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT = typeof UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT;

export interface UpdateFeedFiltersAutobudgetPriorityResultAction {
    type: UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT;
    status: PageStatus;
}

export function updateFeedFiltersAutobudgetPriorityResult(
    status: PageStatus
): UpdateFeedFiltersAutobudgetPriorityResultAction {
    return {
        type: UPDATE_FEED_FILTERS_AUTOBUDGET_PRIORITY_RESULT,
        status
    };
}

export type FeedFilterChangeAutobudgetModalAction =
    | ChangeFeedFiltersAutobudgetPriorityAction
    | UpdateFeedFiltersAutobudgetPriorityAction
    | UpdateFeedFiltersAutobudgetPriorityResultAction;
